// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { DataProcessingAddendumPage } from '../pages/DataProcessingAddendumPage/DataProcessingAddendumPage';

export const Route = createFileRoute('/data-processing-addendum')({
  component: DataProcessingAddendumPage,
});
